module.exports = __webpack_public_path__ + "static/assets/8a460ce856fa81bc6e7f2886cb6a0e1c.png";